import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LibraryPage from './pages/LibraryPage';
import UploadPage from './pages/UploadPage';
import GeneratePage from './pages/GeneratePage';
import ModelDetailPage from './pages/ModelDetailPage';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/library" element={<LibraryPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/generate" element={<GeneratePage />} />
        <Route path="/models/:id" element={<ModelDetailPage />} />
      </Routes>
    </Layout>
  );
}

export default App;
